import { useTranslation } from "react-i18next";
import { useStructureContext } from "../../../context/StructureContext";
import { headerInventory } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { useEffect } from "react";
import { openInventory } from "../../MainFrame/functions/inventory/openInventory";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";

export default function InventoryBox() {
  const user: any = useSelector((state: RootState) => state.data.user);
  const { customUpdate } = useMainContext();
  const { type, searchValues, section, findServiceData } =
    useStructureContext();
  const {
    setWindowValues,
    setModalData,
    setMsg,
    setMsg2,
    closeMsg,
    logoutAction,
  } = useMainContext();
  const { t } = useTranslation();

  useEffect(() => {
    if (
      "mainInfo" in customUpdate.current &&
      customUpdate.current.mainInfo === "INV"
    ) {
      findServiceData(false, false);
      customUpdate.current = {};
    }
  }, [customUpdate.current]);

  return "CODINV" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerInventory}
        data={
          "results" in searchValues[section.id]
            ? searchValues[section.id].results
            : []
        }
        onDoubleClick={(data, index) =>
          openInventory(data.CODINV, "", {
            t,
            user,
            setWindowValues,
            setModalData,
            setMsg,
            setMsg2,
            closeMsg,
            logoutAction,
          })
        }
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
